var render, staticRenderFns
import script from "./StyleMixin.vue?vue&type=script&lang=js"
export * from "./StyleMixin.vue?vue&type=script&lang=js"
import style0 from "./StyleMixin.vue?vue&type=style&index=0&id=671bc6c4&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports